import { render, staticRenderFns } from "./EventNotAvailable.vue?vue&type=template&id=2084d0fb&"
import script from "./EventNotAvailable.vue?vue&type=script&lang=js&"
export * from "./EventNotAvailable.vue?vue&type=script&lang=js&"
import style0 from "./EventNotAvailable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports